

















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { CloverAddOrUpdateViewModel, SquareAccountAddOrUpdateViewModel } from '@/models/payment/squareAccount';
import { Base } from '@/components/common/base';
import { storeService } from '@/shared';
import { ValidationRules } from '@/helper/enum';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class AddCloverccountPage extends Base {
  public vm: CloverAddOrUpdateViewModel = new CloverAddOrUpdateViewModel();
  public form: any = {};
  public formFields: Array<VFields<any>> = [];
  public disableSubmitButton: boolean = false;
  public tenantId: number = 0;
  public enterpriseId: number = 0;
  public created(): void {
    this.setFields();
  }

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'backToStoreEdit') {
      this.$router
        .push({
          name: 'admin.stores.edit',
          params: { id: this.vm.storeId.toString(), tab: 'CloverAccount' },
        })
        .catch((ex) => {
          console.log(ex);
        });
    } else if (methodName === 'submit') {
      if (!this.form.$valid) {
        this.showAlert(false, this.$t('cenposAccounts.alertFormInvalid'));
        this.resetMethodName(methodName);
        return;
      }
      this.submitCloverAccount();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: this.$parent.$t('stores.btnBackToStoreTitle'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$parent.$t('stores.btnBack'),
      click: 'backToStoreEdit',
      icon: 'fas fa-arrow-left',
    });
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
    this.setFields();
    this.vm.storeId = Number(this.$route.params.storeId);

    this.getSquareAccountDetails();
  }

  public setFields(): void {
    this.formFields = [
      {
        key: 'environment',
        required: true,
        type: 'v-alynk-select',
        templateOptions: {
          disabled: false,
          required: true,
          label: 'Environment',
          items: [
            'Production',
            'Sandbox',
          ],
          loading: false,
          rules: [
            v => this.required('Environment', v)
          ]
        },
      },
      {
        key: 'merchantId',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 150,
          label: 'Merchant Id',
          required: true,
          disabled: false,
          rules: [
            v => this.required('Merchant Id', v)
          ]
        },
      },
      {
        key: 'accessToken',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 250,
          label: 'Business Key',
          required: true,
          disabled: false,
          rules: [
            v => this.required('Business Key', v)
          ]
        },
      },
      {
        key: 'publicToken',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 250,
          label: 'Public Token',
          required: true,
          disabled: false,
          rules: [
            v => this.required('Public Token', v)
          ]
        },
      },
      {
        key: 'privateToken',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 250,
          label: 'Private Token',
          required: true,
          disabled: false,
          rules: [
            v => this.required('Private Token', v)
          ]
        },
      },
      {
        key: 'paymentBaseUrl',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 250,
          label: 'Api Url',
          required: true,
          disabled: false,
          rules: [
            v => this.required('Api Url', v)
          ]
        },
      },
    ];
  }

  public validatecloverAccountForm(): Vue & { validate: () => boolean } {
    return this.$refs.cloverAccountForm as Vue & { validate: () => boolean };
  }

  public async submitCloverAccount(): Promise<void> {
    if (this.validatecloverAccountForm().validate()) {
      try {
        this.disableSubmitButton = true;
        this.$emit('update:progress', this.disableSubmitButton);
        await storeService.updateCloverAccounts(
          this.vm.storeId,
          this.vm.account
        );
        this.showAlert(true, "Clover Account successfully saved");

        this.$router.push({
          name: 'admin.stores.edit',
          params: {
            tenantId: this.tenantId.toString(),
            enterpriseId: this.enterpriseId.toString(),
            storeId: this.vm.storeId.toString(),
            tab: 'SquareAccount'
          },
        });
      } finally {
        this.disableSubmitButton = false;
        this.$emit('update:progress', this.disableSubmitButton);
      }
    }
  }

  public async getSquareAccountDetails(): Promise<void> {
    try {
      if (this.vm.merchantId) {
        this.formlyShowSkeleton(this.formFields);
      }

      const response = await storeService.getCloverAccountDetails(
        this.vm.storeId
      );
      if (response) {
        this.vm.account = response;
      }
    } finally {
      if (this.vm.merchantId) {
        this.formlyHideSkeleton(this.formFields);
      }
    }
  }
}
